import React from 'react';

import FullPageModalIFramaContent from 'src/presentation/components/pages/glados/components/FullPageModalIFramaContent';

const ActionAdapterNewEditor = ({ root }) => {
  return <FullPageModalIFramaContent root={root} srcPath="/new" />;
};

export default ActionAdapterNewEditor;
